import { TypedAction } from '../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  RawStoreListStateSlice,
  transformObjects,
} from '../helpers';
import { transformContact } from './contact.transformers';

export function contactReducer(
  state: RawStoreListStateSlice<'contacts'> = {},
  action: TypedAction,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'contacts') {
        const { result, refList } = action.payload;
        return mergeEntities<'contacts'>(
          state,
          transformObjects(
            result.contacts,
            transformContact,
            refList.pathList[1][0],
          ),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/contact/contact.reducer.ts